export function buildEmptyEmailCredentialsForm() {
  return {
    fromAddress: '',
    fromName: '',
    host: '',
    port: '',
    username: '',
    password: '',
  };
}
